if (!!(typeof window !== 'undefined' && window.document) && !window.global) { window.global = window } // compatibility
window.__RENDER_7_COMPONENTS__ = window.__RENDER_7_COMPONENTS__ ? window.__RENDER_7_COMPONENTS__ : {}
window.__RENDER_7_HOT__ = window.__RENDER_7_HOT__ ? window.__RENDER_7_HOT__ : {}
;
function dep (m) { return m.__esModule ? m.default : (m.default || m)};

var host = window.__hostname__
var assetsPath = '/_v/public/assets/v1/published/'

if (!!(typeof window !== 'undefined' && window.document) && window.__RUNTIME__) {
  var generatorMetaTag = document.querySelector("meta[name='generator']")
  var generator = generatorMetaTag && generatorMetaTag.getAttribute('content')
  var isRenderGenerator = generator && generator.indexOf('vtex.render-server') === 0
  var env = __RUNTIME__.publicEndpoint || 'myvtex.com'
  host = isRenderGenerator ? window.location.hostname : __RUNTIME__.workspace + '--' + __RUNTIME__.account + '.' + env
  assetsPath = module.hot
    ? __RUNTIME__.assetServerLinkedPath || '/_v/private/assets/v1/linked/'
    : __RUNTIME__.assetServerPublishedPath || '/_v/public/assets/v1/published/'
}

__webpack_public_path__ = 'https://' + host + assetsPath + 'boticario.store@1.4.44/public/react/'
;
let entry;
  try {
    entry = dep(require('/usr/local/data/build/build_boticario_gimenes/boticario.store@1.4.44/src/react/GiftOccasion.js'));
  } catch (error) {
    throw new Error(`An error happened while requiring the app boticario.store@1.4.44/GiftOccasion, please check your app's code.\n ${error.stack}`)
  }
  if (window.__RENDER_7_RUNTIME__ && window.__RENDER_7_RUNTIME__.withHMR) {
    window.__RENDER_7_COMPONENTS__['boticario.store@1.4.44/GiftOccasion'] = window.__RENDER_7_COMPONENTS__['boticario.store@1.x/GiftOccasion'] = window.__RENDER_7_RUNTIME__.withHMR(module, entry);
  } else {
    window.__RENDER_7_COMPONENTS__['boticario.store@1.4.44/GiftOccasion'] = window.__RENDER_7_COMPONENTS__['boticario.store@1.x/GiftOccasion'] = entry
  }
if (module.hot) {if (!!(typeof window !== 'undefined' && window.document)) {
  require('events').EventEmitter.defaultMaxListeners = 200
  require('/usr/local/data/service/node_modules/webpack/hot/log.js').setLogLevel('error');
  require('/usr/local/data/service/node_modules/webpack/hot/dev-server.js');
  window.__RENDER_7_HOT__['boticario.store@1.4.44'] = window.__RENDER_7_HOT__['boticario.store@1.4.44'] || require('/usr/local/data/service/node_modules/webpack/hot/emitter.js');
  if (window.__RENDER_7_COMPONENTS__['boticario.store@1.4.44/GiftOccasion'] && window.__RENDER_7_COMPONENTS__['boticario.store@1.4.44/GiftOccasion'].hotReload) {
    module.hot.accept('/usr/local/data/build/build_boticario_gimenes/boticario.store@1.4.44/src/react/GiftOccasion.js', function () {
      let reqJoin
      try {
        reqJoin = dep(require('/usr/local/data/build/build_boticario_gimenes/boticario.store@1.4.44/src/react/GiftOccasion.js'))
      } catch (error) {
        throw new Error(`An error happened while requiring the app boticario.store@1.4.44/GiftOccasion, please check your app's code.\n ${error.stack}`)
      }
      window.__RENDER_7_COMPONENTS__['boticario.store@1.4.44/GiftOccasion'].hotReload(reqJoin)
    })
  }
}}